import { render, staticRenderFns } from "./UploadFileMore.vue?vue&type=template&id=601f1779&scoped=true&"
import script from "./UploadFileMore.vue?vue&type=script&lang=js&"
export * from "./UploadFileMore.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileMore.vue?vue&type=style&index=0&id=601f1779&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601f1779",
  null
  
)

export default component.exports